import { NoDataCard } from '@europrocurement/flexy-components';
import { TableBody, TableCell, TableRow } from '@mui/material';
import React from 'react';

export const FlexyDatatableBodyFailed: React.FunctionComponent = function () {
    return (
        <TableBody data-testid="FlexyDatatableBody">
            <TableRow>
                <TableCell
                    colSpan={12}
                    sx={{ height: '45vh' }}
                    data-testid="StatusFailed"
                >
                    <NoDataCard messageOverwrite="Une erreur lors du chargement est survenue." />
                </TableCell>
            </TableRow>
        </TableBody>
    );
};
